'use strict';

var cov_1nw4nvqh3x = function () {
	var path = '/Volumes/Data/Projects/brozeph/node-chess/src/main.js',
	    hash = '9027f9950df7c8245f06da8b135ca6e8298c9b92',
	    Function = function () {}.constructor,
	    global = new Function('return this')(),
	    gcv = '__coverage__',
	    coverageData = {
		path: '/Volumes/Data/Projects/brozeph/node-chess/src/main.js',
		statementMap: {
			'0': {
				start: {
					line: 5,
					column: 0
				},
				end: {
					line: 8,
					column: 2
				}
			},
			'1': {
				start: {
					line: 6,
					column: 20
				},
				end: {
					line: 6,
					column: 52
				}
			},
			'2': {
				start: {
					line: 7,
					column: 22
				},
				end: {
					line: 7,
					column: 47
				}
			}
		},
		fnMap: {
			'0': {
				name: '(anonymous_0)',
				decl: {
					start: {
						line: 6,
						column: 10
					},
					end: {
						line: 6,
						column: 11
					}
				},
				loc: {
					start: {
						line: 6,
						column: 20
					},
					end: {
						line: 6,
						column: 52
					}
				},
				line: 6
			},
			'1': {
				name: '(anonymous_1)',
				decl: {
					start: {
						line: 7,
						column: 16
					},
					end: {
						line: 7,
						column: 17
					}
				},
				loc: {
					start: {
						line: 7,
						column: 22
					},
					end: {
						line: 7,
						column: 47
					}
				},
				line: 7
			}
		},
		branchMap: {},
		s: {
			'0': 0,
			'1': 0,
			'2': 0
		},
		f: {
			'0': 0,
			'1': 0
		},
		b: {},
		_coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
	},
	    coverage = global[gcv] || (global[gcv] = {});

	if (coverage[path] && coverage[path].hash === hash) {
		return coverage[path];
	}

	coverageData.hash = hash;
	return coverage[path] = coverageData;
}();

var _algebraicGameClient = require('./algebraicGameClient');

var _simpleGameClient = require('./simpleGameClient');

// exports
cov_1nw4nvqh3x.s[0]++;
module.exports = {
	create: function create(opts) {
		cov_1nw4nvqh3x.f[0]++;
		cov_1nw4nvqh3x.s[1]++;
		return _algebraicGameClient.AlgebraicGameClient.create(opts);
	},
	createSimple: function createSimple() {
		cov_1nw4nvqh3x.f[1]++;
		cov_1nw4nvqh3x.s[2]++;
		return _simpleGameClient.SimpleGameClient.create();
	}
};
//# sourceMappingURL=main.js.map
